<template>
  <div class="row">
    <component
        v-for="(item, name) in items"
        :key="name"
        :name="name"
        :is="item.component"
        :filters="filters"
        v-bind="item"
        @filter-change="filterChange"
        @labels-change="labelsChange"
        class="col-6 mb-1"
    ></component>
  </div>
</template>

<script>
import BaseWrapper from '../../../../components/filter/v2/wrapper';
import TextFilter from '../../../../components/filter/v2/filters/text-filter';
import ContactFilter from './contact-filter';

export default {
  extends: BaseWrapper,

  components: {
    TextFilter,
    ContactFilter,
  },
}
</script>
